import React, { PureComponent, Fragment } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import { Datepicker, Loader } from 'modules/shared'
import { DateTime } from 'luxon'
import Select from 'react-select'
import { emissToDate, numFormat, formatCNPJ, showNotification, getDecodedToken } from 'helpers'
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { fetchNfes, downloadXML, getDANFE } from '../actions/nfeActions'

const { SearchBar } = Search
const ExportCSV = (props) => {
    const handleClick = () => props.onExport()
    return <button style={{ borderRadius: 0 }} className="btn btn-info btn-sm" disabled={props.disabled} onClick={handleClick}>Exportar CSV</button>
}

class NFeConsulta extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            dateIni: DateTime.local().minus({ days: 3}).toJSDate(),
            dateEnd: new Date(),
            filteredCompanies: [],
            tipo: '',
            transporte: ''
        }
    }

    componentDidMount() {
        this.props.fetchNfes(this.state)
    }

    filterReport() {
        if (DateTime.fromJSDate(this.state.dateIni) <= DateTime.fromJSDate(this.state.dateEnd))
            this.props.fetchNfes(this.state)
        else 
            showNotification('Data inicial deve ser anterior à final.', 'alert-warning', 3000)
    }

    updateDates(dates) {
        if (dates.length >= 1 && (DateTime.fromJSDate(this.state.dateIni).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[0]).toFormat('yyyyMMdd') || DateTime.fromJSDate(this.state.dateEnd).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[1]).toFormat('yyyyMMdd'))) {
            if (dates.length === 1)
                this.setState({ dateIni: dates[0], dateEnd: dates[0] })
            else
                this.setState({ dateIni: dates[0], dateEnd: dates[1] })            
        }
    }

    filterCompanies(value) {
        let _ids = value.map(v => v.value)
        this.setState({
            filteredCompanies: this.props.nfeState.empresas.filter(p => _ids.includes(p._id)).map(p => p._id)
        })
    }
    
    render() {
        let { loading, notas, empresas } = this.props.nfeState

        if (loading)
            return <Loader />

        const user = getDecodedToken()

        empresas = empresas && empresas.length ? empresas : []
        const options = empresas.map(p => Object.assign({}, { value: p._id, label: p.nomeEmpresa }) )

        const acoes = (chave, row) => (
            <div>
                <button style={{ fontSize: '.6rem' }} className="btn btn-sm btn-success py-1" disabled={!row.finalidade} onClick={event => this.props.downloadXML(event.currentTarget, chave)}>
                    <i className="fas fa-download"></i> XML
                </button>
                <button style={{ fontSize: '.6rem' }} className="btn btn-sm btn-primary ml-2 py-1" disabled={!row.finalidade} onClick={event => this.props.getDANFE(event.currentTarget, chave)}>
                    <i className="fas fa-eye"></i> DANFE
                </button>
            </div>
        )



        const columns = [
            { dataField: 'index', text: 'index', sort: false, hidden: true, csvExport: false },
            { dataField: '_id', text: 'CHAVE', sort: false, hidden: true, csvExport: true, csvType: 'String' },
            { dataField: 'nomeEmpresa', text: 'EMPRESA', sort: true },
            { dataField: 'destinatario.cnpj', text: 'CNPJ DESTINÁTARIO', hidden: true, csvFormatter: formatCNPJ },
            { dataField: 'emiss_id', text: 'EMIS.', sort: true, formatter: emissToDate, csvFormatter: emissToDate },
            { dataField: 'numero', text: 'NRO.', sort: true, csvType: 'Number' },
            { dataField: 'emitente.nome', text: 'EMITENTE', sort: true, formatter: (cell, row) => cell + ' - ' + formatCNPJ(row.emitente.cnpj) },
            { dataField: 'emitente.cnpj', text: 'CNPJ EMITENTE', hidden: true, csvFormatter: formatCNPJ },
            { dataField: 'total.vNF', text: 'VALOR', sort: true, formatter: cell => numFormat(cell, 2, true) },
            { dataField: 'detalhes[0].prod.comb.descANP', text: 'PRODUTO', hidden: true, csvExport: true },
            { dataField: 'detalhes[0].prod.qCom', text: 'QUANTIDADE', hidden: true, csvExport: true },
            { dataField: '_id', text: 'AÇÕES', sort: false, csvExport: false, formatter: acoes }
        ]

        const expandRow = {
            renderer: row => (
                <div className="row mx-0 px-0 my-3">
                    {!row.finalidade && <div className="col"><p className="ml-3">Para mais detalhes, aguarde o sistema importar o XML da nota.</p></div>}
                    {row.finalidade && 
                        <div className="col mx-0 px-0">
                            <p className="ml-3 mb-0"><strong>CHAVE ACESSO:</strong> {row._id}</p>
                            <p className="ml-3 mb-0"><strong>TRANSPORTADO POR:</strong> {row.transp && row.transp.cnpj ? `${row.transp.nome} - ${formatCNPJ(row.transp.cnpj)}` : 'Sem informações' }</p>
                            <p className="ml-3 mb-0"><strong>PRODUTOS:</strong></p>
                            {row.detalhes.map((det, idx) => <li className="ml-4 mb-0" key={idx}>{`${det.prod.xProd} - ${numFormat(det.prod.qCom, 2)} ${det.prod.uCom} / VL UNIT. ${numFormat(det.prod.vUnCom, 4, true)} VL TOT. ${numFormat(det.prod.vProd, 2, true)}`}</li>)}
                        </div>
                    }
                </div>
            ),
            showExpandColumn: true,
            onlyOneExpanding: true,
            expandByColumnOnly: true,
            expandColumnRenderer: ({ expanded }) => !expanded ? <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-plus fa-stack-1x fa-inverse"></i></span> : <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-minus fa-stack-1x fa-inverse"></i></span>,
            expandHeaderColumnRenderer: ({ isAnyExpands }) => !isAnyExpands ? <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-plus fa-stack-1x fa-inverse"></i></span> : <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-minus fa-stack-1x fa-inverse"></i></span>
        }

        const toolkitProps = { keyField: 'index', data: notas || [], search: { searchFormatted: true }, columns, exportCSV: true }

        return (
            <div className="container-fluid mx-0">

                <div className="row mx-0">
                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Select
                            isDisabled={user && (user.empresa !== "99" && user.empresa !== "9999") }
                            options={options}
                            defaultValue={empresas.filter(p => this.state.filteredCompanies.includes(p._id)).map(p => Object.assign({}, { value: p._id, label: p.nomeEmpresa }) )}
                            isMulti
                            placeholder="Filtrar empresas..."
                            classNamePrefix="react-select"
                            onChange={value => this.filterCompanies(value)} 
                        />
                    </div>

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Datepicker
                            defaultDate={[this.state.dateIni, this.state.dateEnd]}
                            onChange={dates => this.updateDates(dates)}
                        />
                    </div>

                    <div className="col mt-2">
                        <button onClick={() => this.filterReport()} className="btn btn-primary btn-sm">
                            <i className="fas fa-sync-alt pr-2"></i>
                            Filtrar                        
                        </button>
                    </div>
                </div>  

                <div className="row mb-4 mx-0">

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Select
                            options={[{ value: 'C', label: 'Combustível' }, { value: 'P', label: 'Produto/Serviço' }]}
                            defaultValue={this.state.tipo !== '' ? this.state.tipo === 'C' ? { value: 'C', label: 'Combustível' } : { value: 'P', label: 'Produto/Serviço' } : undefined }
                            placeholder="Filtrar tipo..."
                            isSearchable={false}
                            isClearable
                            classNamePrefix="react-select"
                            onChange={selecionado => this.setState({ tipo: selecionado ? selecionado.value : '' })} 
                        />
                    </div>

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Select
                            options={[{ value: 'rdp', label: 'Transportadora RDP' }, { value: 'outros', label: 'Outros' }]}
                            defaultValue={this.state.transporte !== '' ? this.state.transporte === 'rdp' ? { value: 'rdp', label: 'Transportadora RDP' } : { value: 'outros', label: 'Outros' } : undefined }
                            placeholder="Filtrar transporte..."
                            isSearchable={false}
                            isClearable
                            classNamePrefix="react-select"
                            onChange={selecionado => this.setState({ transporte: selecionado ? selecionado.value : '' })} 
                        />
                    </div>
                
                </div>              

                <div className="row mx-0">

                    <div className="col mr-4">
                    
                        <ToolkitProvider {...toolkitProps}>
                            {props => 
                                <Fragment>
                                    <div className="row mb-3">
                                        <div className="col col-sm-5 col-md-3">
                                            <SearchBar delay={ 250 } placeholder="Pesquisar na tabela..." className="form-control-sm" {...props.searchProps} />
                                        </div>
                                        <div className="col">
                                            <ExportCSV {...props.csvProps} disabled={props.baseProps.data.length ? false : true} />
                                            <p className="float-right"><strong>Total:</strong> {numFormat(toolkitProps.data.map(d => d.total.vNF).reduce((acc, v) => acc + v, 0), 2, true)}</p>
                                        </div>
                                    </div>
                                    
                                    <BootstrapTable
                                        {...props.baseProps}
                                        expandRow={expandRow}
                                        bootstrap4
                                        defaultSorted={[{ dataField: 'emiss_id', order: 'desc' }]}
                                        hover
                                        classes="table-sm table-font-size"
                                        wrapperClasses="table-responsive"
                                        pagination={paginationFactory({ sizePerPage: 50, sizePerPageList: [50, 100, 150, 200], showTotal: true, paginationTotalRenderer: (from, to, size) => (<span className="pl-3">Exibindo linhas {from} a {to} de {size}</span>) })}
                                        noDataIndication={'Sem dados'}
                                    />
                                </Fragment>
                            }
                        </ToolkitProvider>
                    </div>
                        
                </div>

            </div>
        )
    }   
}

const mapStateToProps = store => ({ nfeState: store.nfeState })
const mapDispatchToProps = dispatch => bindActionCreators({ fetchNfes, downloadXML, getDANFE }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(NFeConsulta)
